module.exports = __webpack_public_path__ + "img/arrow-down.88685893.svg";